import { ComponentsMap } from "./types";
import Alert from "./components/Alert";
import Avatar from "./components/Avatar";
import Badge from "./components/Badge";
import Box from "./components/Box";
import Breadcrumbs from "./components/Breadcrumbs";
import Button from "./components/Button";
import Card from "./components/Card";
import Checkbox from "./components/Checkbox";
import Chip from "./components/Chip";
import CircularProgress from "./components/CircularProgress";
import Container from "./components/Container";
import Dialog from "./components/Dialog";
import Divider from "./components/Divider";
import Grid from "./components/Grid";
import GridCell from "./components/GridCell";
import FlexBox from "./components/FlexBox";
import FlexItem from "./components/FlexItem";
import Link from "./components/Link";
import MaterialIcon from "./components/MaterialIcon";
import Menu from "./components/Menu";
import Paper from "./components/Paper";
import RadioGroup from "./components/RadioGroup";
import Select from "./components/Select";
import Stack from "./components/Stack";
import Table from "./components/Table";
import Tabs from "./components/Tabs";
import Text from "./components/Text";
import TextField from "./components/TextField";
import ToggleButton from "./components/ToggleButton";
import Tooltip from "./components/Tooltip";
import TreeView from "./components/TreeView";
import Typography from "./components/Typography";
import IconButton from "./components/IconButton";
import DataGrid from "./components/DataGrid";
import DataGridColumn from "./components/DataGridColumn";
import DataGridActionColumn from "./components/DataGridActionColumn";
import DataGridNavColumn from "./components/DataGridNavColumn";
import NavButton from "./components/NavButton";
import TabPanel from "./components/TabPanel";
import MonacoEditor from "./components/MonacoEditor";
import PageDesigner from "./PageDesigner/Designer";
import MapComponents from "./components/MapComponents";
import CardActions from "./components/CardActions";
import DialogActions from "./components/DialogActions";
import Switch from "./components/Switch";
import DebugObject from "./components/DebugObject";
import TextAreaCodeEditor from "./components/TextAreaCodeEditor";

export const componentsMap: ComponentsMap = {
	Alert: { name: "Alert", icon: "warning", component: Alert, schema: [], allowedChild: [] },
	Avatar: { name: "Avatar", icon: "account_circle", component: Avatar, schema: [], allowedChild: [] },
	Badge: { name: "Badge", icon: "verified", component: Badge, schema: [], allowedChild: [] },
	Box: {
		name: "Box",
		icon: "check_box_outline_blank",
		component: Box,
		schema: [
			{ name: "width", label: "Width", required: false, type: "string" },
			{ name: "height", label: "Height", required: false, type: "string" },
			{ name: "padding", label: "Padding", required: false, type: "string" },
			{ name: "backgroundColor", label: "Background Color", required: false, type: "string" },
			{ name: "flexBox", label: "As Flex Box", required: false, defaultValue: "False", type: "list", options: ["False", "True"] },
			{ name: "flex", label: "Flex", required: false, type: "string" },
			{ name: "submitAction", label: "Submit Action", required: false, type: "pageAction" },
		],
	},
	Breadcrumbs: { name: "Breadcrumbs", icon: "route", component: Breadcrumbs, schema: [], allowedChild: [] },
	Button: {
		name: "Button",
		icon: "smart_button",
		component: Button,
		schema: [
			{ name: "icon", label: "Icon", required: false, type: "string" },
			{ name: "label", label: "Label", required: true, type: "string" },
			{ name: "variant", label: "Variant", required: false, defaultValue: "text", type: "list", options: ["text", "contained", "outlined"] },
			{ name: "color", label: "Color", required: false, defaultValue: "inherit", type: "list", options: ["inherit", "primary", "secondary", "success", "error", "info", "warning", "string"] },
			{ name: "width", label: "Width", required: false, type: "string" },
			{ name: "tooltip", label: "Tooltip", required: false, type: "string" },
			{ name: "submitAction", label: "Submit Action", required: false, type: "pageAction" },
			{ name: "disabled", label: "Disabled", required: false, type: "string" },
			{ name: "loadingButton", label: "Loading Button", required: false, defaultValue: "False", type: "list", options: ["False", "True"] },
		],
		allowedChild: [],
	},
	NavButton: {
		name: "Navigation Button",
		icon: "near_me",
		component: NavButton,
		schema: [
			{ name: "icon", label: "Icon", required: true, type: "string" },
			{ name: "label", label: "Label", required: true, type: "string" },
			{ name: "variant", label: "Variant", required: false, defaultValue: "text", type: "list", options: ["text", "contained", "outlined"] },
			{ name: "color", label: "Color", required: false, defaultValue: "inherit", type: "list", options: ["inherit", "primary", "secondary", "success", "error", "info", "warning", "string"] },
			{ name: "width", label: "Width", required: true, type: "string" },
			{ name: "path", label: "Path", required: false, type: "string" },
			{ name: "tooltip", label: "Tooltip", required: false, type: "string" },
			{ name: "disabled", label: "Disabled", required: false, type: "string" },
		],
		allowedChild: [],
	},
	IconButton: {
		name: "Icon Button",
		icon: "add_reaction",
		component: IconButton,
		schema: [
			{ name: "icon", label: "Icon", required: true, type: "string" },
			{ name: "variant", label: "Variant", required: false, defaultValue: "text", type: "list", options: ["text", "contained", "outlined"] },
			{ name: "color", label: "Color", required: false, defaultValue: "inherit", type: "list", options: ["inherit", "primary", "secondary", "success", "error", "info", "warning", "string"] },
			{ name: "width", label: "Width", required: true, type: "string" },
			{ name: "fontSize", label: "Font Size", required: false, type: "string" },
			{ name: "tooltip", label: "Tooltip", required: false, type: "string" },
			{ name: "submitAction", label: "Submit Action", required: true, type: "pageAction" },
			{ name: "disabled", label: "Disabled", required: false, type: "string" },
		],
		allowedChild: [],
	},
	Card: {
		name: "Card",
		icon: "space_dashboard",
		component: Card,
		schema: [
			{ name: "title", label: "Title", required: false, type: "string" },
			{ name: "subHeader", label: "SubHeader", required: false, type: "string" },
			{ name: "width", label: "Width", required: false, type: "string" },
			{ name: "height", label: "Height", required: true, type: "string" },
			{ name: "minHeight", label: "Min Height", required: true, type: "string" },
			{ name: "maxHeight", label: "Max Height", required: true, type: "string" },
			{ name: "flexBox", label: "As Flex Box", required: false, defaultValue: "False", type: "list", options: ["False", "True"] },
			{ name: "flex", label: "Flex", required: false, type: "string" },
		],
	},
	CardActions: {
		name: "Card Actions",
		icon: "space_dashboard",
		component: CardActions,
		schema: [],
		allowedChild: ["IconButton", "NavButton", "Button", "MapComponents"],
	},
	Checkbox: { name: "Checkbox", icon: "check_box", component: Checkbox, schema: [], allowedChild: [] },
	Chip: {
		name: "Chip",
		icon: "badge",
		component: Chip,
		schema: [
			{ name: "label", label: "Label", required: true, type: "string" },
			{ name: "color", label: "Color", required: false, defaultValue: "default", type: "list", options: ["default", "primary", "secondary", "error", "info", "success", "warning"] },
			{ name: "variant", label: "Variant", required: false, defaultValue: "filled", type: "list", options: ["filled", "outlined"] },
			{ name: "size", label: "Size", required: false, defaultValue: "medium", type: "list", options: ["medium", "small"] },
		],
		allowedChild: [],
	},
	CircularProgress: { name: "Circular Progress", icon: "restart_alt", component: CircularProgress, schema: [], allowedChild: [] },
	Container: { name: "Container", icon: "takeout_dining", component: Container, schema: [] },
	DataGrid: {
		name: "DataGrid",
		icon: "view_compact",
		component: DataGrid,
		schema: [
			{ name: "rows", label: "Rows", required: true, type: "string" },
			{ name: "autoHeight", label: "Auto Height", required: false, defaultValue: "False", type: "list", options: ["True", "False"] },
			{ name: "density", label: "Density", required: false, defaultValue: "standard", type: "list", options: ["standard", "compact", "comfortable"] },
			{ name: "rowHeight", label: "Row Height", defaultValue: "52", required: false, type: "string" },
			{ name: "pageSize", label: "Page Size", required: false, type: "number" },
		],
		allowedChild: ["DataGridColumn", "DataGridActionColumn", "DataGridNavColumn", "MapComponents"],
	},
	DataGridColumn: {
		name: "DataGrid Column",
		icon: "view_column",
		component: DataGridColumn,
		schema: [
			{ name: "field", label: "Field", required: true, type: "string" },
			{ name: "headerName", label: "Header Name", required: true, type: "string" },
			{ name: "width", label: "Width", required: false, type: "string" },
			{ name: "flex", label: "Flex", required: false, type: "number" },
			{ name: "align", label: "Align", required: false, defaultValue: "left", type: "list", options: ["left", "right", "center"] },
			{ name: "headerAlign", label: "Header Align", required: false, defaultValue: "left", type: "list", options: ["left", "right", "center"] },
			{ name: "type", label: "Column Type", required: false, defaultValue: "singleSelect", type: "list", options: ["singleSelect", "actions"] },
			{ name: "sortable", label: "Sortable", required: false, defaultValue: "True", type: "list", options: ["True", "False"] },
		],
		allowedChild: [],
	},
	DataGridActionColumn: {
		name: "DataGrid Action Column",
		icon: "view_column",
		component: DataGridActionColumn,
		schema: [
			{ name: "icon", label: "Icon", required: false, type: "string" },
			{ name: "label", label: "Label", required: false, type: "string" },
			{ name: "submitAction", label: "Submit Action", required: true, type: "pageAction" },
			{ name: "disabled", label: "Disabled", required: false, type: "string" },
		],
		allowedChild: [],
	},
	DataGridNavColumn: {
		name: "DataGrid Nav Column",
		icon: "view_column",
		component: DataGridNavColumn,
		schema: [
			{ name: "icon", label: "Icon", required: false, type: "string" },
			{ name: "label", label: "Label", required: false, type: "string" },
			{ name: "path", label: "Path", required: false, type: "string" },
			{ name: "disabled", label: "Disabled", required: false, type: "string" },
		],
		allowedChild: [],
	},
	Dialog: {
		name: "Dialog",
		icon: "web_asset",
		component: Dialog,
		schema: [
			{ name: "title", label: "Title", required: true, type: "string" },
			{ name: "closeHandler", label: "Close Handler", required: true, type: "pageAction" },
			{ name: "openCondition", label: "Open Condition", required: true, type: "string" },
			{ name: "maxWidth", label: "Max Width", required: false, defaultValue: "False", type: "list", options: ["False", "xs", "sm", "md", "lg", "xl"] },
			{ name: "fullWidth", label: "Full Width", required: false, defaultValue: "False", type: "list", options: ["False", "True"] },
			{ name: "width", label: "Width", required: true, type: "string" },
			{ name: "height", label: "Height", required: true, type: "string" },
			{ name: "loadingIndicator", label: "Loading Indicator", required: false, type: "string" },
		],
	},
	DialogActions: {
		name: "Dialog Actions",
		icon: "web_asset",
		component: DialogActions,
		schema: [],
		allowedChild: ["IconButton", "NavButton", "Button", "MapComponents"],
	},
	Divider: { name: "Divider", icon: "horizontal_rule", component: Divider, schema: [], allowedChild: [] },
	Grid: {
		name: "Grid",
		icon: "grid_view",
		component: Grid,
		schema: [{ name: "spacing", label: "Spacing", required: true, defaultValue: 0, type: "number" }],

		allowedChild: ["GridCell", "MapComponents"],
	},
	GridCell: { name: "Grid Cell", icon: "grid_view", component: GridCell, schema: [{ name: "size", label: "Size", required: true, defaultValue: 12, type: "number" }] },
	FlexBox: {
		name: "Flex Box",
		icon: "space_dashboard",
		component: FlexBox,
		schema: [
			{ name: "flexDirection", label: "Flex Direction", required: false, defaultValue: "row", type: "list", options: ["row", "row-reverse", "column", "column-reverse"] },
			{ name: "justifyContent", label: "Justify Content", required: false, defaultValue: "flex-start", type: "list", options: ["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly"] },
			{ name: "alignItems", label: "Align Items", required: false, defaultValue: "stretch", type: "list", options: ["flex-start", "flex-end", "center", "baseline", "stretch"] },
			{ name: "flexWrap", label: "Flex Wrap", required: false, defaultValue: "nowrap", type: "list", options: ["nowrap", "wrap"] },
			{ name: "gap", label: "Gap", required: false, defaultValue: "0", type: "number" },
			{ name: "width", label: "Width", required: false, type: "string" },
			{ name: "height", label: "Height", required: false, type: "string" },
			{ name: "padding", label: "Padding", required: false, type: "string" },
			{ name: "backgroundColor", label: "Background Color", required: false, type: "string" },
			{ name: "flex", label: "Flex", required: false, type: "string" },
		],
		allowedChild: ["FlexItem", "MapComponents"],
	},
	FlexItem: {
		name: "Flex Item",
		icon: "space_dashboard",
		component: FlexItem,
		schema: [
			{ name: "flexGrow", label: "Flex Grow", required: false, defaultValue: "0", type: "number" },
			{ name: "flexShrink", label: "Flex Shrink", required: false, defaultValue: "1", type: "number" },
			{ name: "flexBasis", label: "Flex Basis", required: false, defaultValue: "auto", type: "string" },
			{ name: "alignSelf", label: "Align Self", required: false, defaultValue: "auto", type: "list", options: ["auto", "flex-start", "flex-end", "center", "baseline", "stretch"] },
			{ name: "width", label: "Width", required: true, type: "string" },
			{ name: "height", label: "Height", required: true, type: "string" },
			{ name: "minHeight", label: "Min Height", required: true, type: "string" },
			{ name: "maxHeight", label: "Max Height", required: true, type: "string" },
			{ name: "flexBox", label: "As Flex Box", required: false, defaultValue: "False", type: "list", options: ["False", "True"] },
		],
	},
	Link: { name: "Link", icon: "link", component: Link, schema: [], allowedChild: [] },
	Menu: { name: "Menu", icon: "menu_open", component: Menu, schema: [], allowedChild: [] },
	MaterialIcon: {
		name: "Material Icon",
		icon: "emoji_emotions",
		component: MaterialIcon,
		schema: [
			{ name: "icon", label: "Icon", required: true, type: "string" },
			{ name: "color", label: "Color", required: false, defaultValue: "inherit", type: "list", options: ["inherit", "disabled", "action", "primary", "secondary", "error", "info", "success", "warning"] },
			{ name: "fontSize", label: "Font Size", required: false, defaultValue: "medium", type: "list", options: ["inherit", "small", "medium", "large"] },
			{ name: "width", label: "Width", required: true, type: "string" },
		],
		allowedChild: [],
	},
	Paper: {
		name: "Paper",
		icon: "article",
		component: Paper,
		schema: [
			{ name: "elevation", label: "Elevation", required: true, type: "number" },
			{ name: "variant", label: "Variant", required: false, defaultValue: "elevation", type: "list", options: ["elevation", "outlined"] },
			{ name: "width", label: "Width", required: false, type: "string" },
			{ name: "height", label: "Height", required: false, type: "string" },
			{ name: "padding", label: "Padding", required: false, type: "string" },
			{ name: "backgroundColor", label: "Background Color", required: false, type: "string" },
			{ name: "flexBox", label: "As Flex Box", required: false, defaultValue: "False", type: "list", options: ["False", "True"] },
			{ name: "flex", label: "Flex", required: false, type: "string" },
		],
	},
	RadioGroup: { name: "Radio Group", icon: "radio_button_checked", component: RadioGroup, schema: [], allowedChild: [] },
	Select: {
		name: "Select",
		icon: "arrow_drop_down_circle",
		component: Select,
		schema: [
			{ name: "binding", label: "Binding", required: true, type: "string" },
			{ name: "label", label: "Label", required: true, type: "string" },
			{ name: "placeholder", label: "Placeholder", required: true, type: "string" },
			{ name: "variant", label: "Variant", required: false, defaultValue: "outlined", type: "list", options: ["filled", "outlined", "standard"] },
			{ name: "width", label: "Width", required: false, type: "string" },
			{ name: "size", label: "Size", required: false, defaultValue: "medium", type: "list", options: ["medium", "small"] },
			{ name: "focused", label: "Focused", required: false, defaultValue: "Initial", type: "list", options: ["Initial", "True", "False"] },
			{ name: "fullWidth", label: "Full Width", required: false, defaultValue: "Initial", type: "list", options: ["Initial", "True", "False"] },
			{ name: "options", label: "Options", required: true, type: "string" },
			{ name: "optionLabel", label: "Option Label", required: true, type: "string" },
			{ name: "optionValue", label: "Option Value", required: true, type: "string" },
			{ name: "allowEmptyOption", label: "Allow Empty Option", required: false, defaultValue: "True", type: "list", options: ["True", "False"] },
			{ name: "emptyOptionLabel", label: "Empty Option Label", required: true, type: "string" },
		],
		allowedChild: ["SelectOption", "MapComponents"],
	},
	Stack: {
		name: "Stack",
		icon: "view_agenda",
		component: Stack,
		schema: [
			{ name: "direction", label: "Direction", required: false, defaultValue: "column", type: "list", options: ["row", "row-reverse", "column", "column-reverse"] },
			{ name: "alignItems", label: "Align Items", required: false, defaultValue: "flex-start", type: "list", options: ["flex-start", "center", "flex-end", "stretch", "baseline"] },
			{ name: "justifyContent", label: "Justify Content", required: false, defaultValue: "flex-start", type: "list", options: ["flex-start", "center", "flex-end", "space-between", "space-around", "space-evenly"] },
			{ name: "spacing", label: "Spacing", required: true, type: "number" },
			{ name: "flex", label: "Flex", required: false, type: "string" },
		],
	},
	Table: { name: "Table", icon: "view_list", component: Table, schema: [] },
	Tabs: {
		name: "Tabs",
		icon: "tab",
		component: Tabs,
		schema: [
			{ name: "orientation", label: "Orientation", required: false, defaultValue: "horizontal", type: "list", options: ["horizontal", "vertical"] },
			{ name: "flex", label: "Flex", required: false, type: "string" },
			{ name: "variant", label: "variant", required: false, defaultValue: "scrollable", type: "list", options: ["scrollable", "standard", "fullWidth"] },
			{ name: "tabElevation", label: "tabElevation", required: false, type: "number" },
		],
		allowedChild: ["TabPanel", "MapComponents"],
	},
	TabPanel: {
		name: "Tab Panel",
		icon: "tab",
		component: TabPanel,
		schema: [
			{ name: "label", label: "Label", required: true, type: "string" },
			{ name: "tooltip", label: "Tooltip", required: true, type: "string" },
			{ name: "icon", label: "Icon", required: false, type: "string" },
			{ name: "width", label: "Width", required: false, type: "string" },
			{ name: "height", label: "Height", required: false, type: "string" },
			{ name: "padding", label: "Padding", required: false, type: "string" },
			{ name: "backgroundColor", label: "Background Color", required: false, type: "string" },
			{ name: "flexBox", label: "As Flex Box", required: false, defaultValue: "False", type: "list", options: ["False", "True"] },
		],
	},
	Text: { name: "Text", icon: "title", component: Text, schema: [{ name: "text", label: "Text", required: true, type: "string" }], allowedChild: [] },
	TextField: {
		name: "TextField",
		icon: "text_fields",
		component: TextField,
		schema: [
			{ name: "binding", label: "Binding", required: true, type: "string" },
			{ name: "label", label: "Label", required: true, type: "string" },
			{ name: "placeholder", label: "Placeholder", required: true, type: "string" },
			{ name: "variant", label: "Variant", required: false, defaultValue: "outlined", type: "list", options: ["filled", "outlined", "standard"] },
			{ name: "size", label: "Size", required: false, defaultValue: "medium", type: "list", options: ["medium", "small"] },
			{ name: "fontFamily", label: "Font Family", required: true, type: "string" },
			{ name: "fontSize", label: "Front Size", required: true, type: "number" },
			{ name: "focused", label: "Focused", required: false, defaultValue: "Initial", type: "list", options: ["Initial", "True", "False"] },
			{ name: "fullWidth", label: "Full Width", required: false, defaultValue: "Initial", type: "list", options: ["Initial", "True", "False"] },
			{ name: "maxLines", label: "Max Lines", required: false, type: "number" },
			{ name: "minWidth", label: "Min Width", required: false, type: "string" },
			{ name: "maxWidth", label: "Max Width", required: false, type: "string" },
		],
		allowedChild: [],
	},
	ToggleButton: { name: "Toggle Button", icon: "toggle_off", component: ToggleButton, schema: [], allowedChild: [] },
	Tooltip: { name: "Tooltip", icon: "textsms", component: Tooltip, schema: [{ name: "title", label: "Title", required: true, type: "string" }] },
	TreeView: { name: "Tree View", icon: "account_tree", component: TreeView, schema: [], allowedChild: [] },
	Typography: {
		name: "Typography",
		icon: "text_format",
		component: Typography,
		schema: [
			{ name: "variant", label: "Variant", required: true, defaultValue: "body1", type: "list", options: ["h1", "h2", "h3", "subtitle1", "subtitle2", "body1", "body2", "button", "caption", "overline", "Page Header"] },
			{ name: "color", label: "Color", required: false, type: "string" },
			{ name: "fontSize", label: "Font Size", required: false, type: "string" },
		],
		allowedChild: ["Text", "MapComponents"],
	},
	MonacoEditor: {
		name: "Monaco Editor",
		icon: "edit_note",
		component: MonacoEditor,
		schema: [
			{ name: "binding", label: "Binding", required: true, type: "string" },
			{ name: "height", label: "Height", required: true, type: "string" },
			{ name: "minHeight", label: "Min Height", required: true, type: "string" },
			{ name: "maxHeight", label: "Max Height", required: true, type: "string" },
			{ name: "flex", label: "Flex", required: false, type: "string" },
		],
		allowedChild: [],
	},
	TextAreaCodeEditor: {
		name: "Text Area Code Editor",
		icon: "edit_note",
		component: TextAreaCodeEditor,
		schema: [
			{ name: "binding", label: "Binding", required: true, type: "string" },
			{ name: "height", label: "Height", required: true, type: "string" },
			{ name: "minHeight", label: "Min Height", required: true, type: "string" },
			{ name: "maxHeight", label: "Max Height", required: true, type: "string" },
			{ name: "flex", label: "Flex", required: false, type: "string" },
		],
		allowedChild: [],
	},
	PageDesigner: {
		name: "Page Designer",
		icon: "dashboard_customize",
		component: PageDesigner,
		schema: [
			{ name: "mockInitScript", label: "Mockup Init Script", required: true, type: "string" },
			{ name: "pageContent", label: "Page Content", required: true, type: "string" },
			{ name: "pageActions", label: "Page Actions", required: true, type: "string" },
		],
		allowedChild: [],
	},
	MapComponents: {
		name: "Map Components",
		icon: "loop",
		component: MapComponents,
		schema: [
			{ name: "binding", label: "Binding", required: true, type: "string" },
			{ name: "variable", label: "Variable", required: true, type: "string" },
		],
	},
	Switch: {
		name: "Switch",
		icon: "toggle_on",
		component: Switch,
		schema: [{ name: "binding", label: "Binding", required: true, type: "string" }],
		allowedChild: [],
	},
	DebugObject: { name: "Debug Object", icon: "adb", component: DebugObject, schema: [{ name: "object", label: "Object", required: true, type: "string" }], allowedChild: [] },
};
